import "./App.css";
import { useEffect, useState } from "react";
import LogModal from "./Modals/logModal";
import CallModal from "./Modals/callModal";
import ReviewModal from "./Modals/reviewModal";
import PaymentModal from "./Modals/paymentModal";
import CardPaymentModal from "./Modals/cardpaymentModal";
import OutboundModal from "./Modals/outboundModal";

function App({ agentId }) {
  const [islogModalOpen, setislogModalOpen] = useState(false);
  const [iscardpaymentModalOpen, setiscardpaymentModalOpen] = useState(false);
  const [isoutboundModalOpen, setisoutboundModalOpen] = useState(false);
  const [iscallModalOpen, setiscallModalOpen] = useState(false);
  const [isreviewModalOpen, setisreviewModalOpen] = useState(false);
  const [ispaymentModalOpen, setispaymentModalOpen] = useState(false);
  const [timer, setTimer] = useState(0);
  console.log("agentIdagentIdagentIdagentId", agentId);
  const resetTimer = () => {
    setTimer(0);
  };

  const showlogModal = () => {
    setislogModalOpen(!islogModalOpen);
  };
  const showcardPaymentModal = () => {
    setiscardpaymentModalOpen(!iscardpaymentModalOpen);
  };

  const showoutboundModal = () => {
    setisoutboundModalOpen(!isoutboundModalOpen);
  };

  const showcallModal = () => {
    setiscallModalOpen(!iscallModalOpen);
    setislogModalOpen(false);
  };
  const showreviewModal = () => {
    setiscallModalOpen(false);
    setisreviewModalOpen(!isreviewModalOpen);
  };
  const showpaymentModal = () => {
    setisreviewModalOpen(false);
    setispaymentModalOpen(!ispaymentModalOpen);
  };

  return (
    <>
      <div className="white-label">
        <img
          src="https://white-lable-frontend.s3.us-east-1.amazonaws.com/assets/icons/widget.svg"
          alt="..."
          className="widget cursor-pointer"
          onClick={showlogModal}
        />
        <LogModal
          islogModalOpen={islogModalOpen}
          showcardPaymentModal={showcardPaymentModal}
          showlogModal={showlogModal}
          showcallModal={showcallModal}
          agentId={"agent_01jxf40yewemq8r8cm5k8n451z"}
        />
        <CardPaymentModal
          iscardpaymentModalOpen={iscardpaymentModalOpen}
          showcardPaymentModal={showcardPaymentModal}
          showoutboundModal={showoutboundModal}
        />
        <OutboundModal
          isoutboundModalOpen={isoutboundModalOpen}
          showoutboundModal={showoutboundModal}
          showcallModal={showcallModal}
        />
        <CallModal
          iscallModalOpen={iscallModalOpen}
          showcallModal={showcallModal}
          showreviewModal={showreviewModal}
          timer={timer}
          setTimer={setTimer}
        />
        <ReviewModal
          showpaymentModal={showpaymentModal}
          showreviewModal={showreviewModal}
          isreviewModalOpen={isreviewModalOpen}
          resetTimer={resetTimer}
        />
        <PaymentModal
          showpaymentModal={showpaymentModal}
          ispaymentModalOpen={ispaymentModalOpen}
        />
      </div>
    </>
  );
}

export default App;
